/**
 * i18n (locked decision, CLAUDE.md/roadmap §10.3): Dutch is the *source*
 * language, English becomes a translation file later — never a rewrite.
 * @wordpress/i18n's __() returns the source string verbatim unless locale
 * data for another locale has been loaded, so writing Dutch directly as the
 * default text domain string is correct today and translator-ready later.
 */
import { __, _n, _x, setLocaleData } from '@wordpress/i18n';

const config = window.etmConfig || {};
if (config.localeData) {
  setLocaleData(config.localeData, 'etm');
}

export { __, _n, _x };
